@if (!showSetup2FA) {
<img class="logo" src="/assets/logo_deebr_marge.png" width="180" height="72" loading="eager" />
}

@if (showMessages.error && errors.length && !submitted) {
<nb-alert outline="danger" role="alert">
  <p class="alert-title"><b></b></p>
  <ul class="alert-message-list">
    @for (error of errors; track error) {
    <li class="alert-message">{{ error }}</li>
    }
  </ul>
</nb-alert>
}

@if (showMessages.success && messages.length && !submitted) {
<nb-alert outline="success" role="alert">
  <ul class="alert-message-list">
    @for (message of messages; track message) {
    <li class="alert-message">{{ message }}</li>
    }
  </ul>
  <!-- Retry Link -->
  <div *ngIf="showSetup2FA || isAwaiting2FAActivation" style="margin-top: 10px; text-align: center;">
    <a href="#" (click)="retryActivation(); $event.preventDefault()"
      style="color: inherit; text-decoration: underline; font-size: 0.9em;">
      Je n'ai toujours pas reçu l'email
    </a>
  </div>
</nb-alert>
}

@if (showSetup2FA) {
<h5 class="title">Securisation du compte requise</h5>
<p class="sub-title">Pour continuer, vous devez configurer la double authentification.</p>

<div class="text-center" style="margin-bottom: 20px;">
  <p style="text-align: left; margin-bottom: 15px;"><strong>Étape 1 :</strong> Téléchargez l'application <strong>Google
      Authenticator</strong> (ou Authy) sur votre téléphone depuis l'App Store ou Google Play.</p>

  <p style="text-align: left;"><strong>Étape 2 :</strong> Scannez ce QR Code avec l'application</p>
  <nb-spinner *ngIf="!setupQrCode"></nb-spinner>
  <img *ngIf="setupQrCode" [src]="setupQrCode" style="max-width: 200px; border: 1px solid #ccc; margin-top: 10px;">
</div>

<form (ngSubmit)="confirmSetup()" #formSetup="ngForm" aria-labelledby="title">
  <p style="text-align: left;"><strong>Étape 3 :</strong> Entrez le code généré</p>
  <div class="form-control-group">
    <input nbInput fullWidth [(ngModel)]="verificationCode" #code="ngModel" name="code" id="input-code"
      placeholder="123456" fieldSize="large" autofocus required>
  </div>

  <button nbButton fullWidth status="danger" size="large" [disabled]="submitted || !formSetup.valid"
    [class.btn-pulse]="submitted">
    Activer et Continuer
  </button>
</form>

} @else if (show2FA) {
<h5 class="title">Authentification à deux facteurs</h5>
<p class="sub-title">Veuillez entrer le code généré par votre application.</p>

<form (ngSubmit)="verify2FA()" #form2fa="ngForm" aria-labelledby="title">
  <div class="form-control-group">
    <label for="input-code">Code de vérification</label>
    <input nbInput fullWidth [(ngModel)]="verificationCode" #code="ngModel" name="code" id="input-code"
      placeholder="123456" fieldSize="large" autofocus required>
  </div>

  <div class="form-control-group accept-group">
    <nb-checkbox name="trustDevice" [(ngModel)]="trustDevice">
      Ne plus me demander sur cet appareil pendant 30 jours
    </nb-checkbox>
  </div>

  <button nbButton fullWidth status="danger" size="large" [disabled]="submitted || !form2fa.valid"
    [class.btn-pulse]="submitted">
    Vérifier
  </button>

  <div class="links clearfix">
    <a href="#" (click)="show2FA = false; $event.preventDefault()" style="float: left;">Retour</a>
    <a href="#" (click)="lostCode(); $event.preventDefault()" style="float: right;">Code perdu ?</a>
  </div>
</form>
} @else {
<form (ngSubmit)="login()" #form="ngForm" aria-labelledby="title">
  <div class="form-control-group">
    <label for="input-email">Nom d'utilisateur</label>
    <input nbInput fullWidth [(ngModel)]="user.username" #username="ngModel" name="email" id="input-email"
      placeholder="utilisateur" fieldSize="large" autofocus
      [status]="username.dirty ? (username.invalid ? 'danger' : 'success') : 'basic'"
      [required]="getConfigValue('forms.validation.username.required')"
      [attr.aria-invalid]="username.invalid && username.touched ? true : null" />
    @if (username.invalid && username.touched) {
    @if (username.errors && username.errors['required']) {
    <p class="caption status-danger">
      Nom d'utilisateur requis
    </p>
    }
    }
  </div>

  <div class="form-control-group">
    <label for="input-password">Mot de passe</label>
    <input nbInput fullWidth [(ngModel)]="user.password" #password="ngModel" name="password" type="password"
      id="input-password" placeholder="Password" fieldSize="large"
      [status]="password.dirty ? (password.invalid ? 'danger' : 'success') : 'basic'"
      [required]="getConfigValue('forms.validation.password.required')"
      [attr.aria-invalid]="password.invalid && password.touched ? true : null" />
    <a class="forgot-password caption-2" routerLink="/auth/request-password">Mot de passe oublié ?</a>
  </div>

  <div class="form-control-group accept-group">
    @if (rememberMe) {
    <nb-checkbox status="danger" name="rememberMe" [(ngModel)]="user.rememberMe">
      Se souvenir de moi
    </nb-checkbox>
    }
  </div>

  <button nbButton fullWidth status="danger" size="large" [disabled]="submitted || !form.valid"
    [class.btn-pulse]="submitted">
    Se connecter
  </button>
</form>
}